<template>
  <div>
      <!-- 標題 begin -->
      <div class="container-fluid my-4">
        <div class="row">
          <div class="col-6">
            <h6 class="m-0 text-mcf-color">{{ title }}</h6>
          </div>
          <div class="col-6">
          </div>
        </div>
      </div>
      <!-- 標題 end -->
      <ListContainer itemKey="orderId" :fetch="fetch" :filter="filter" :emptyHint="emptyHint" :spinner="spinnerStyle" @initialized="onListInitialized">
      <!-- OrderList begin -->
        <template v-slot:list-item="{ item }">
          <div class="m-3 bg-white border border-light rounded-md overflow-auto">
            <div class="d-flex align-items-center justify-content-between bg-gray100" @click="onOrderToggle(item)">
              <div class="p-3 font-size-md flex-grow-1">{{ $t('order.orderId') }} {{ item.orderId }}</div>
              <!-- <OrderButtonGroup :order="item" :buttonConfigBase="buttonConfigBase" /> -->
              <div>
                <a class="px-2 text-gray600" href="javascript:void(0);">
                  <span class="material-icons">
                    <template v-if="item.isCollapsed">keyboard_arrow_up</template>
                    <template v-else>keyboard_arrow_down</template>
                  </span>
                </a>
              </div>
            </div>
            <b-collapse :id="item.orderId">
              <template v-if="item.isCollapsed">
                <div class="d-flex p-3">
                  <!-- <OrderDetail class="mt-n4 mr-3 w-100" :order="item" /> -->
                  <RedeemHistoryDetail class="mt-n4 mr-3 w-100" :order="item" />
                  <div class="border border-light p-3 rounded" style="visibility: hidden">
                    <Timeline class="timeline flex-column-reverse" :order="item" />
                  </div>
                </div>
              </template>
            </b-collapse>
          </div>
        </template>
      <!-- OrderList end -->
      </ListContainer>
      <RightSheet :isOpen="isWriteOffPageVisible" @close="closeWriteOffPage()">
        <div class="flex-grow-1 overflow-auto bg-gray100">
          <router-view />
        </div>
      </RightSheet>
  </div>
</template>

<script>
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import ListContainer from '@/components/ListContainer.vue';
import RightSheet from '@/components/RightSheet.vue';
import RedeemHistoryDetail from '@/components/redeemHistory/RedeemHistoryDetail.vue';
import Timeline from '@/components/redeemHistory/Timeline.vue';

import pageSettingGetter from '@/utils/pageSettingGetter';

import sctService from '@/services/sctService';

export default {
  components: {
    ListContainer,
    RightSheet,
    RedeemHistoryDetail,
    Timeline,
  },
  data() {
    return {
      title: '',
      // 讀取spinner樣式
      spinnerStyle: '',
      // 空白頁設定
      emptyHint: {},
      // filter
      filter: { dayFilter: 90 },
    };
  },
  computed: {
    // 核銷頁是否為開啟中
    isWriteOffPageVisible() {
      return this.$route.name === 'writeOffPage';
    },
  },
  methods: {
    // 取得資料 observable
    fetch(pagination, filter) {
      const vm = this;
      const payload = {
        companyId: vm.$store.state.companyId,
        limit: pagination.limit,
        offset: pagination.offset,
        dayFilter: filter.dayFilter,
      };
      const headers = { accesstoken: vm.$store.state.accessToken };

      return forkJoin({
        list: sctService.getRedeemOrders(payload, headers).pipe(
          map((res) => {
            if (res.response && res.response.data) {
              const newOrders = res.response.data.map((order) => {
                const items = [];
                order.itemInfo.forEach((item) => {
                // 需做核銷
                  if (item.isWriteOff) {
                    item.writeOffInfo.forEach((writeOff) => {
                      items.push({ ...item, writeOff });
                    });
                  } else {
                    for (let i = 0; i < item.qty; i += 1) {
                      items.push({ ...item });
                    }
                  }
                });
                return {
                  ...order,
                  items,
                  totalQty: order.itemInfo.reduce((sum, cur) => sum + cur.qty, 0),
                  isCollapsed: false,
                  hasLoaded: false,
                };
              });

              return newOrders;
            }
            return [];
          }),
        ),
      });
    },
    // 列表初始化完成
    onListInitialized(data) {
      if (data[0]) {
        this.onOrderToggle(data[0]);
      }
    },
    // 訂單展開/縮合
    onOrderToggle(order) {
      const vm = this;
      order.isCollapsed = !order.isCollapsed;
      order.hasLoaded = true;

      // toggle collapse
      vm.$root.$emit('bv::toggle::collapse', order.orderId);
    },
    // 關閉核銷頁
    closeWriteOffPage() {
      // 回到到兌禮歷程列表
      this.$router.go(-1);
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getPageSetting', 'RedeemHistory')
      .then((setting) => {
        // title
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;

        // 空白頁設定
        vm.emptyHint.desc = pageSettingGetter.getFunctionWording(setting, 'BlankPageWording');
        vm.emptyHint.img = pageSettingGetter.getFunction(setting, 'BlankPagePic').picUrl;
        vm.emptyHint.class = 'w-50 m-auto';
        if (pageSettingGetter.getFunction(setting, 'BlankPageGoToRedeemItem').isShow) {
          vm.emptyHint.button = {
            text: pageSettingGetter.getFunctionWording(setting, 'BlankPageGoToRedeemItem'),
            onClick() {
              vm.$router.push({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
            },
          };
        }
      });

    // 取得頁面 style
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((res) => {
        vm.spinnerStyle = res.layoutType === '0' ? 'light' : 'secondary';
      });
  },
};
</script>

<style>

</style>
